var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMailOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_envelope-open",
    transform: "translate(-92 -113)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_30px",
    "data-name": "30px",
    width: 30,
    height: 30,
    transform: "translate(92 113)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon_envelope-open-2",
    "data-name": "icon_envelope-open",
    d: "M18,16.312A1.687,1.687,0,0,1,16.312,18H1.687A1.687,1.687,0,0,1,0,16.312V7.057A1.687,1.687,0,0,1,.646,5.729c.876-.687,1.6-1.243,5.773-4.272C7.011,1.025,8.184-.012,9,0c.816-.012,1.99,1.026,2.581,1.457,4.173,3.028,4.9,3.586,5.773,4.272A1.687,1.687,0,0,1,18,7.057ZM15.691,9.4a.281.281,0,0,0-.4-.067c-.8.593-1.95,1.431-3.712,2.71C10.989,12.474,9.816,13.512,9,13.5c-.816.012-1.988-1.025-2.581-1.457C4.657,10.765,3.51,9.927,2.707,9.333a.281.281,0,0,0-.4.067l-.319.464a.281.281,0,0,0,.065.386c.8.594,1.95,1.431,3.7,2.7.713.52,1.987,1.681,3.244,1.672,1.256.009,2.53-1.152,3.244-1.672,1.753-1.272,2.9-2.108,3.7-2.7a.281.281,0,0,0,.065-.386Z",
    transform: "translate(98 118.352)",
    fill: "#72383D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailOpen);
export default __webpack_public_path__ + "static/media/icon_mail_open.bff19488a25c1b827dbbb304f26ca563.svg";
export { ForwardRef as ReactComponent };